function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "prefix__a-bluegas",
  x1: "75.475%",
  x2: "31.478%",
  y1: "2.628%",
  y2: "90.295%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#7E2889"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#1587C8"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "url(#prefix__a-bluegas)",
  d: "M23.1 6.56c-3.795 3.335-3.3 8.747-3.3 8.747S14.19 6.833 16.5 0C14.245 4.592 4.4 5.795 8.8 18.587 3.245 16.509 3.3 9.84 3.3 9.84S0 13.12 0 19.68C0 26.926 5.91 32.8 13.2 32.8c7.29 0 13.2-5.874 13.2-13.12 0-6.67-4.785-6.615-3.3-13.12z"
}), React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  d: "M23.2 20.8c0 5.302-4.298 9.6-9.6 9.6"
}));

var SvgBlueGas = function SvgBlueGas(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBlueGas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blueGas.2cb61d26.svg";
export { ForwardRef as ReactComponent };